import { render, staticRenderFns } from "./CartSparkle.vue?vue&type=template&id=0e135d9c&"
import script from "./CartSparkle.vue?vue&type=script&lang=js&"
export * from "./CartSparkle.vue?vue&type=script&lang=js&"
import style0 from "./CartSparkle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CartSparkle.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CartSparkle.vue"
export default component.exports